import { render, staticRenderFns } from "./WaiterListDownload.vue?vue&type=template&id=a4a97f16&scoped=true&lang=pug"
import script from "./WaiterListDownload.vue?vue&type=script&lang=ts"
export * from "./WaiterListDownload.vue?vue&type=script&lang=ts"
import style0 from "./WaiterListDownload.vue?vue&type=style&index=0&id=a4a97f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a97f16",
  null
  
)

export default component.exports